import type { SelectHTMLAttributes } from 'react';

interface SelectOption { value: string; label: string }

interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  helperText?: string;
  error?: string;
  options: SelectOption[];
  placeholder?: string;
}

export default function Select({ label, helperText, error, options, placeholder, className = '', id, style, ...props }: SelectProps) {
  const selectId = id || label?.toLowerCase().replace(/\s/g, '-');
  return (
    <div>
      {label && <label htmlFor={selectId} className="form-label">{label}</label>}
      <select
        id={selectId}
        className={`form-select ${className}`}
        style={error ? { borderColor: 'var(--red)', ...style } : style}
        aria-invalid={!!error}
        aria-describedby={error ? `${selectId}-error` : helperText ? `${selectId}-helper` : undefined}
        {...props}
      >
        {placeholder && <option value="">{placeholder}</option>}
        {options.map(o => (
          <option key={o.value} value={o.value}>{o.label}</option>
        ))}
      </select>
      {helperText && !error && <p id={`${selectId}-helper`} className="form-helper">{helperText}</p>}
      {error && <p id={`${selectId}-error`} className="form-helper form-helper-error" role="alert">{error}</p>}
    </div>
  );
}
